import React, { useState, useEffect, useRef } from "react";

import StudentTemplate from "../../component/StudentTemplate";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import Api from "../../component/Api";
import Swal from "sweetalert2";

const StudentReadmission = () => {
  const { http } = Api();
  const semesterCache = useRef({}); // cache semesters per current semester

  const [eventStatus, setEventStatus] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [semester, setSemester] = useState([]);
  const [selectedSemester, setSelectedSemester] = useState(null);
  const [loading, setLoading] = useState(false);
  const [readmissionDet, setReadmissionDetails] = useState([]);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [availableSemesters, setAvailableSemesters] = useState([]);
  const [currentSemester, setCurrentSemester] = useState("");
  const [editError, setEditError] = useState("");
  const [feeAmount, setFeeAmount] = useState(0);
  const [readmissionYears, setReadmissionYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [currentYear, setCurrentYear] = useState("");
  const [semesterDisabled, setSemesterDisabled] = useState(false);
  const [returnRemark, setReturnRemark] = useState("");

  //--------------JS FOR MODAL OPEN AND CLOSE----------------//
  const openModal = async (readmissionsem = "") => {
    try {
      // 🧭 If semester was passed (edit mode)
      if (readmissionsem && Number(readmissionsem) > 0) {
        const editResponse = await http.get("/Student/getEditSemesters");
        const editSemesterData = (editResponse.data.semesters || []).map(
          (sem) => ({
            value: sem.semester_no,
            label: sem.semester_name,
          })
        );
        setSemester(editSemesterData);

        const selectedOption = editSemesterData.find(
          (sem) => sem.value === Number(readmissionsem)
        );
        setSelectedSemester(selectedOption || null);
      } else {
        setSelectedSemester(null);
        setSelectedYear(null);
      }

      setShowModal(true);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to load dropdown options.");
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleSemesterChange = (selectedOption) => {
    setSelectedSemester(selectedOption);
    console.log("Selected semester:", selectedOption.value);
     fetchReadmissionYears(selectedOption.value);
  };

  //-----------API CALLs--------------------//
  useEffect(() => {
    fetchReadmissionDetails();
    fetchEventStatus();
    fetchSemesters(); // ⬅️ New: load semesters once
    fetchReadmissionYears();
  }, []);
  //api for event status
  const fetchEventStatus = async () => {
    try {
      const response = await http.get("/Student/getstudentEvents", {
        params: {
          // Any required parameters can be added here
        },
      });

      const { event_status } = response.data;
      setEventStatus(event_status);
      console.log({ eventStatus });
    } catch (error) {
      console.error("Error fetching event status:", error);
    }
  };
  const fetchSemesters = async () => {
    try {
      const semResponse = await http.get("/Student/getSemesters");
      const semesterData = (semResponse.data.semesters || []).map((sem) => ({
        value: sem.semester_no,
        label: sem.semester_name,
      }));
      setSemester(semesterData);
    } catch (error) {
      console.error("Error fetching semesters:", error);
      toast.error("Failed to load semester options.");
    }
  };

  const fetchReadmissionYears = async (semester='') => {
    try {
    //  const response = await http.get("/Student/getReadmissionYear");
      const response = await http.get("/Student/getReadmissionYear", {
        params: {
          semester:semester
        },
      });
      const yearData = (response.data.readmission_year || []).map((y) => ({
        value: y,
        label: y,
      }));
      setReadmissionYears(yearData);
    } catch (error) {
      console.error("Error loading readmission years:", error);
    }
  };

  // listing students based on discipline
  const fetchReadmissionDetails = async () => {
    try {
      setLoading(true);
      const response = await http.get("/Student/getReadmissionDetails", {
        params: {
          // Any required parameters can be added here
        },
      });

      const { readmissionDetails, feeAmount } = response.data || {};

      // 🧩 Save readmission details
      if (Array.isArray(readmissionDetails)) {
        setReadmissionDetails(readmissionDetails);
      } else {
        setReadmissionDetails([]);
      }

      // 💰 Save exact fee amount from backend
      setFeeAmount(feeAmount);

      // setStatus(event_status === "active");
    } catch (error) {
      // toast.error("Error fetching courses!");
      setReadmissionDetails([]);
    } finally {
      setLoading(false);
    }
  };

  //api for submit buttons
  const handleStudentsAction = async (submitType) => {
    let semester = selectedSemester ? selectedSemester.value : null;
    let reyear = selectedYear ? selectedYear.value : null;
    if (!semester) {
      toast.error("Please select a Semester!");
      return;
    }
    if (!reyear) {
      toast.error("Please select a Year!");
      return;
    }
    // You can access selectedSemester.value or selectedSemester.label
    const { isConfirmed } = await Swal.fire({
      title: "Are you sure?",
      text: "This action will Submit your application.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Save it!",
      cancelButtonText: "Cancel",
    });

    if (!isConfirmed) return;
    let uploadSuccess = false;
    try {
      const payload = {
        semester: semester,
        readmissionyear: selectedYear.value,
        submit_type: submitType,
      };

      const res = await http.post("/Student/saveReadmissionDetails", payload);

      if (res.data.update_status === 1) uploadSuccess = true;
      if (uploadSuccess) {
        // ✅ Close modal first
        setShowModal(false);
        await fetchReadmissionDetails();
        await Swal.fire({
          title: "Success!",
          text: "Application Submitted successfully.",
          icon: "success",
        });
      } else {
        toast.error("Failed to Submit application.");
      }
      //  Refresh whole student list so UI updates correctly
    } catch (error) {
      console.error("Error updating or fetching student data:", error);
      toast.error("Failed to perform action");
    }
  };

  const handlePrintCertificate = async (semester) => {
    try {
      const { http } = Api();

      // Get student details from localStorage
      const studentDetails = JSON.parse(
        localStorage.getItem("student_details")
      );

      if (!studentDetails || !studentDetails[0]?.accountid) {
        toast.error("Student information not found");
        return;
      }

      const accountId = studentDetails[0].accountid;

      const response = await http.get("College/readmissionCertificatePdf", {
        params: {
          accountid: accountId,
          semester: semester,
        },
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `ReadmissionCertificate_${accountId}_${semester}.pdf`;
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Unable to download certificate");
    }
  };

  // 🧭 Fetch Semesters for Editing
  const handleEditApplication = async (
    semester,
    applicationId,
    readmissionyear,
    return_remarks
  ) => {
    setShowEditModal(true);
    setCurrentSemester(semester);
    setCurrentYear(readmissionyear);
    setReturnRemark(return_remarks || "");
    setSelectedSemester("");
    setSelectedYear("");
    setEditError("");
    setEditLoading(true);

    try {
      let semesterData = [];

      // 🧩 1️⃣ Use cached data if available
      if (semesterCache.current[semester]) {
        semesterData = semesterCache.current[semester];
        console.log("Loaded semesters from cache:", semesterData);
      } else {
        // 🧩 2️⃣ Otherwise, fetch from API
        const response = await http.get(`/Student/getEditSemesters`, {
          params: { semester },
        });

        semesterData = (response.data.semesters || []).map((sem) => ({
          value: sem.semester_no,
          label: sem.semester_name,
        }));

        // cache for next time
        semesterCache.current[semester] = semesterData;
      }

      // 🧩 3️⃣ Determine if only current semester is returned
      const sameSemOnly =
        semesterData.length === 1 &&
        String(semesterData[0].value) === String(semester);

      // 🧩 4️⃣ Apply logic to auto-select and disable field if same
      if (sameSemOnly) {
        setSelectedSemester(semesterData[0]);
        setSemesterDisabled(true);
      } else {
        setSemesterDisabled(false);
      }

      // 🧩 5️⃣ Update available semester list
      setAvailableSemesters(semesterData);

      // 🧩 6️⃣ No need to call getReadmissionYear again, already preloaded in useEffect
    } catch (error) {
      console.error("Error loading edit modal data:", error);
      setEditError("Error loading semesters. Please try again.");
    } finally {
      setEditLoading(false);
    }
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setSelectedSemester("");
    setSelectedYear("");
    setCurrentSemester("");
    setCurrentYear("");

    setEditError("");
  };

  // 💾 Save Edited Application
  const handleSaveEdit = async () => {
    setEditError("");

    // 🟢 Validation: check if fields are selected
    if (!selectedSemester) {
      setEditError("Please select a new semester.");
      return;
    }

    if (!selectedYear) {
      setEditError("Please select a readmission year.");
      return;
    }

    // 🟢 Validation: same semester as current
    // if (String(currentSemester) === String(selectedSemester.value)) {
    //   setEditError("New semester cannot be the same as current semester.");
    //   return;
    // }

    // 🟢 Validation: same year as existing
    if (String(currentYear) === String(selectedYear.value)) {
      setEditError("New readmission year cannot be the same as current year.");
      return;
    }

    const { isConfirmed } = await Swal.fire({
      title: "Are you sure?",
      text: "This will update the selected application semester and year.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Update it!",
      cancelButtonText: "Cancel",
    });

    if (!isConfirmed) return;

    setSaveLoading(true);

    try {
      const payload = {
        semester: selectedSemester.value,
        readmissionyear: selectedYear.value,
        submit_type: "edit",
      };

      const res = await http.post("/Student/saveReadmissionDetails", payload);

      if (res.data.update_status === 1) {
        setShowEditModal(false);
        await fetchReadmissionDetails();
        await Swal.fire({
          title: "Success!",
          text: "Application updated successfully.",
          icon: "success",
        });
      } else {
        setEditError(res.data.message || "Failed to update application.");
      }
    } catch (error) {
      console.error("Error updating application:", error);
      setEditError("Error updating application. Please try again.");
    } finally {
      setSaveLoading(false);
    }
  };

  const handleReadmissionPayment = async (readmission, isRepay = false) => {
    try {
      const semester = readmission.semester;
      const amount = feeAmount; // fetched from your API

      if (!semester || !amount) {
        toast.error("Invalid payment details. Please try again.");
        return;
      }

      const result = await Swal.fire({
        title: isRepay ? "Confirm Repayment" : "Confirm Payment",
        html: `
          <p class="fw-bold mb-2">
            You are about to make a payment of <strong>₹${amount}</strong> 
            for <strong>Semester ${semester}</strong>.
          </p>
          <p class="mb-0">Do you wish to continue?</p>
        `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: isRepay ? "Yes, Repay" : "Yes, Pay",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        focusCancel: true,
      });

      if (!result.isConfirmed) return;

      const payload = {
        semester: semester.toString(),
        readmission_amount: amount.toString(),
      };

      const res = await http.post(
        "/Student/readmissionPaymentByStudent",
        payload
      );

      if (res.data?.url && res.data?.reqParam) {
        const { url, reqParam } = res.data;

        const form = document.createElement("form");
        form.method = "POST";
        form.action = url;
        form.id = "frmpaymentaction";

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "epay_req_params";
        input.value = reqParam;

        form.appendChild(input);
        document.body.appendChild(form);

        form.submit();
      } else {
        toast.error(res.data?.message || "Payment initiation failed!");
      }
    } catch (error) {
      console.error("Payment error:", error);
      toast.error(
        error.response?.data?.message || "Failed to proceed with payment!"
      );
    }
  };

  //-----------Custom Styles for Select---------------------//
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: "150px",
      overflowY: "auto",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "150px",
      overflowY: "auto",
      scrollbarWidth: "thin",
      scrollbarColor: "#888 #f1f1f1",
    }),

    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      "&::-webkit-scrollbar": {
        width: "8px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "4px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
  };
  const toRoman = (num) => {
    const romans = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII"];
    return romans[num - 1] || num; // fallback if number is out of range
  };

  //-----------Design Part---------------------//
  return (
    <StudentTemplate>
      <ToastContainer />
      <div className="col-12 mb-0 order-5 order-md-5">
        <div className="card tranaction-card">
          <div className="card-header card-no-border">
            <div className="d-flex justify-content-center align-items-center mb-3 mb-md-4">
              <h3 className="card-title text-center mb-4 font-weight-bold text-black mobile">
                Application for Readmission{" "}
              </h3>
            </div>

            {/* --- Add / Edit Button or Status --- */}
            {eventStatus === null ? (
              <div className="card-body text-center">
                <span className="text-muted">Loading status...</span>
              </div>
            ) : eventStatus === "active" ? (
              <div className="card-body p-2 p-md-3 text-center text-md-end">
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  style={{ minWidth: "160px", maxWidth: "200px" }}
                  onClick={openModal}
                >
                  <i className="fa fa-plus mr-2"></i> New Application
                </button>
              </div>
            ) : (
              <div className="card-body p-2 p-md-3 text-center">
                <span className="text-danger font-weight-bold">
                  Readmission applications are currently closed.
                </span>
              </div>
            )}

            <div className="card-body p-2 p-md-3">
              {/* -------------------- Mobile Card View -------------------- */}
              <div className="d-md-none">
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2 text-muted small">
                      Loading applications...
                    </p>
                  </div>
                ) : readmissionDet.length > 0 ? (
                  <div className="">
                    {readmissionDet.map((readmission, index) => (
                      <div key={readmission.id} className="col-12">
                        <div className="card border shadow-sm">
                          <div className="card-body p-3">
                            {/* Header Section */}
                            <div className="d-flex justify-content-between align-items-center mt-3 pb-2 border-bottom">
                              <div>
                                <h6 className="mb-1 font-weight-bold text-dark">
                                  Semester {toRoman(readmission.semester)}
                                </h6>
                                <small className="text-muted">
                                  Readmission Year:{" "}
                                  {readmission.readmissionyear}
                                </small>
                              </div>
                              <span
                                className="badge bg-secondary"
                                style={{ fontSize: "0.75rem" }}
                              >
                                #{index + 1}
                              </span>
                            </div>

                            {/* Status Section */}
                            <div className="mb-3 mt-3">
                              <div className="d-flex align-items-start">
                                <i className="fa fa-info-circle text-primary me-2 mt-1"></i>
                                <div className="small text-dark">
                                  <span className="text-muted">
                                    Application Status:
                                  </span>{" "}
                                  {readmission.application_status_description ===
                                  "Application Approved" ? (
                                    <span
                                      className="badge bg-success fw-bold"
                                      style={{
                                        display: "inline",
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {
                                        readmission.application_status_description
                                      }
                                    </span>
                                  ) : (
                                    <span
                                      className="fw-bold"
                                      style={{
                                        display: "inline",
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {
                                        readmission.application_status_description
                                      }
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* Action Buttons */}
                            {eventStatus === "active" && (
                              <div className="d-flex gap-2 mt-3 pt-2 border-top">
                                {/* 🖨️ Print Certificate button */}
                                {readmission.application_status_description ===
                                  "Application Approved" && (
                                  <button
                                    className="btn btn-secondary btn-sm flex-fill"
                                    onClick={() =>
                                      handlePrintCertificate(
                                        readmission.semester
                                      )
                                    }
                                  >
                                    <i className="fa fa-print me-1"></i>
                                    Print Certificate
                                  </button>
                                )}

                                {/* 🟢 Eligible for Payment */}
                                {readmission.eligible_for_payment == 1 && (
                                  <button
                                    className="btn btn-success btn-sm flex-fill"
                                    onClick={() =>
                                      handleReadmissionPayment(readmission)
                                    }
                                  >
                                    <i className="fa fa-credit-card me-1"></i>
                                    Make Payment
                                  </button>
                                )}

                                {/* 🟠 Eligible for Re-Payment */}
                                {readmission.eligible_for_repayment == 1 && (
                                  <button
                                    className="btn btn-warning btn-sm flex-fill"
                                    onClick={() =>
                                      handleReadmissionPayment(readmission)
                                    }
                                  >
                                    <i className="fa fa-refresh me-1"></i>
                                    Repay
                                  </button>
                                )}

                                {/* 🔵 Eligible for Edit */}
                                {readmission.eligible_for_edit == 1 && (
                                  <button
                                    className="btn btn-primary btn-sm flex-fill"
                                    onClick={() =>
                                      handleEditApplication(
                                        readmission.semester,
                                        readmission.Id,
                                        readmission.readmissionyear,
                                        readmission.return_remarks
                                      )
                                    }
                                  >
                                    <i className="fa fa-edit me-1"></i>
                                    Edit Application
                                  </button>
                                )}

                                {/* 🔒 No Actions Available */}
                                {readmission.eligible_for_edit == 0 &&
                                  readmission.eligible_for_payment == 0 &&
                                  readmission.eligible_for_repayment == 0 &&
                                  readmission.application_status_description !==
                                    "Application Approved" && (
                                    <div className="flex-fill text-center small text-muted py-2">
                                      No actions available
                                    </div>
                                  )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-5">
                    <i
                      className="fa fa-inbox text-muted mb-3"
                      style={{ fontSize: "3rem" }}
                    ></i>
                    <p className="text-muted mb-0">
                      No readmission applications found.
                    </p>
                    {eventStatus === "active" && (
                      <small className="text-muted d-block mt-2">
                        Click "New Application" to get started.
                      </small>
                    )}
                  </div>
                )}
              </div>

              {/* -------------------- Desktop Table View -------------------- */}
              <div className="table-responsive d-none d-md-block">
                <table className="table st-table-hover align-middle table-bordered">
                  <thead className="table-dark">
                    <tr>
                      <th className="text-center">Semester</th>
                      <th className="text-center">Readmission Year</th>
                      <th className="text-center">Status</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="5" className="text-center py-5">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <p className="mt-2 text-muted mb-0">
                            Loading applications...
                          </p>
                        </td>
                      </tr>
                    ) : readmissionDet.length > 0 ? (
                      readmissionDet.map((readmission, index) => (
                        <tr key={readmission.id}>
                          <td className="text-center font-weight-bold">
                            {toRoman(readmission.semester)}{" "}
                          </td>
                          <td className="text-center">
                            {readmission.readmissionyear}
                          </td>
                          <td className="text-center">
                            <span
                              className={`badge border ${
                                readmission.application_status_description ===
                                "Application Approved"
                                  ? "bg-success text-white"
                                  : "bg-light text-dark"
                              }`}
                            >
                              {readmission.application_status_description}
                            </span>
                          </td>
                          <td className="text-center align-middle">
                            <div className="d-flex justify-content-center flex-wrap gap-2">
                              {/* 🖨️ Print Certificate button */}
                              {readmission.application_status_description ===
                                "Application Approved" && (
                                <button
                                  className="btn btn-secondary btn-sm"
                                  style={{ minWidth: "140px" }}
                                  onClick={() =>
                                    handlePrintCertificate(readmission.semester)
                                  }
                                >
                                  <i className="fa fa-print me-1"></i>
                                  Print Certificate
                                </button>
                              )}

                              {/* ✅ Payment button */}
                              {readmission.eligible_for_payment == 1 &&
                                eventStatus === "active" && (
                                  <button
                                    className="btn btn-success btn-sm"
                                    style={{ minWidth: "120px" }}
                                    onClick={() =>
                                      handleReadmissionPayment(readmission)
                                    }
                                  >
                                    <i className="fa fa-credit-card me-1"></i>
                                    Pay ₹{feeAmount}
                                  </button>
                                )}

                              {/* 🔁 Repayment button */}
                              {readmission.eligible_for_repayment == 1 &&
                                eventStatus === "active" && (
                                  <button
                                    className="btn btn-warning btn-sm"
                                    style={{ minWidth: "120px" }}
                                    onClick={() =>
                                      handleReadmissionPayment(
                                        readmission,
                                        true
                                      )
                                    } // optional param for repay
                                  >
                                    <i className="fa fa-undo me-1"></i>
                                    Repay
                                  </button>
                                )}

                              {/* ✏️ Edit Application button */}
                              {readmission.eligible_for_edit == 1 &&
                                eventStatus === "active" && (
                                  <button
                                    className="btn btn-primary btn-sm"
                                    style={{ minWidth: "140px" }}
                                    onClick={() =>
                                      handleEditApplication(
                                        readmission.semester,
                                        readmission.Id,
                                        readmission.readmissionyear,
                                        readmission.return_remarks
                                      )
                                    }
                                  >
                                    <i className="fa fa-edit me-1"></i>
                                    Edit Application
                                  </button>
                                )}

                              {/* No actions */}
                              {readmission.eligible_for_edit == 0 &&
                                readmission.eligible_for_payment == 0 &&
                                readmission.eligible_for_repayment == 0 &&
                                readmission.application_status_description !==
                                  "Application Approved" &&
                                eventStatus === "active" && (
                                  <span className="text-muted small">—</span>
                                )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center py-5">
                          <i
                            className="fa fa-inbox text-muted mb-2"
                            style={{ fontSize: "2rem" }}
                          ></i>
                          <p className="text-muted mb-0">
                            No readmission applications found.
                          </p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Application Modal */}
      </div>
      {/* Readmission New Application Modal */}
      {showModal && (
        <div
          className="modal fade show d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: "rgba(0,0,0,0.6)",
            backdropFilter: "blur(4px)",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1050,
            padding: "0.5rem",
            boxSizing: "border-box",
            animation: "fadeIn 0.2s ease-out",
          }}
        >
          <div
            className="modal-dialog"
            style={{
              width: "100%",
              maxWidth: "500px",
              margin: "auto",
              maxHeight: "90vh",
              animation: "slideUp 0.3s ease-out",
            }}
          >
            <div
              className="modal-content"
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                maxHeight: "90vh",
                height: "auto",
                overflow: "hidden",
                borderRadius: "12px",
                border: "1px solid rgba(0,0,0,0.1)",
                boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
              }}
            >
              {/* Header */}
              <div
                className="modal-header"
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  background: "#fff",
                  color: "#1a1a1a",
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  borderBottom: "2px solid #e8eaed",
                  padding: "1rem 1.25rem",
                }}
              >
                <h5
                  className="modal-title"
                  style={{
                    fontWeight: "600",
                    fontSize: "1.1rem",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    color: "#202124",
                  }}
                >
                  <div
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "8px",
                      background:
                        "linear-gradient(135deg, #4285f4 0%, #1967d2 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "0.9rem",
                    }}
                  >
                    <i class="fa-solid fa-book-open"></i>{" "}
                  </div>
                  Readmission Application
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                  style={{
                    opacity: 0.6,
                    transition: "opacity 0.2s",
                    fontSize: "0.75rem",
                  }}
                  onMouseEnter={(e) => (e.target.style.opacity = 1)}
                  onMouseLeave={(e) => (e.target.style.opacity = 0.6)}
                ></button>
              </div>

              {/* Body */}
              <div
                className="modal-body"
                style={{
                  flex: 1,
                  overflowY: "auto",
                  WebkitOverflowScrolling: "touch",
                  minHeight: 0,
                  padding: "0rem",
                  backgroundColor: "#fafbfc",
                }}
              >
                <div className="form theme-form">
                  <div
                    className="card"
                    style={{
                      border: "none",
                      borderRadius: "8px",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                    }}
                  >
                    <div
                      className="card-body custom-input"
                      style={{ padding: "1.25rem" }}
                    >
                      <div className="row">
                        <div className="col-12 mb-3">
                          <label
                            style={{
                              fontWeight: "600",
                              color: "#495057",
                              marginBottom: "0.375rem",
                              fontSize: "0.9rem",
                            }}
                          >
                            Semester <span className="errorclr">*</span>
                          </label>
                          <Select
                            id="semester"
                            name="semester"
                            className="form"
                            styles={{
                              ...customStyles,
                              control: (base, state) => ({
                                ...base,
                                borderRadius: "6px",
                                borderColor: state.isFocused
                                  ? "#667eea"
                                  : "#dee2e6",
                                boxShadow: state.isFocused
                                  ? "0 0 0 2px rgba(102,126,234,0.1)"
                                  : "none",
                                transition: "all 0.2s",
                                minHeight: "40px",
                                "&:hover": {
                                  borderColor: "#667eea",
                                },
                              }),
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            options={semester}
                            value={selectedSemester}
                            onChange={handleSemesterChange}
                            maxMenuHeight={150}
                            isSearchable={false}
                            openMenuOnFocus={true}
                            placeholder="Select Semester"
                          />
                        </div>
                        <div className="col-12 mb-3">
                          <label
                            style={{
                              fontWeight: "600",
                              color: "#495057",
                              marginBottom: "0.375rem",
                              fontSize: "0.9rem",
                            }}
                          >
                            Readmission Year <span className="errorclr">*</span>
                          </label>
                          <Select
                            id="readmissionYear"
                            name="readmissionYear"
                            className="form"
                            styles={{
                              ...customStyles,
                              control: (base, state) => ({
                                ...base,
                                borderRadius: "6px",
                                borderColor: state.isFocused
                                  ? "#667eea"
                                  : "#dee2e6",
                                boxShadow: state.isFocused
                                  ? "0 0 0 2px rgba(102,126,234,0.1)"
                                  : "none",
                                transition: "all 0.2s",
                                minHeight: "40px",
                                "&:hover": {
                                  borderColor: "#667eea",
                                },
                              }),
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            options={readmissionYears}
                            value={selectedYear}
                            onChange={setSelectedYear}
                            maxMenuHeight={150}
                            menuPlacement="auto"
                            isSearchable={false}
                            openMenuOnFocus={true}
                            placeholder="Select Readmission Year"
                          />
                        </div>
                        <div className="col-12 mt-1">
                          <button
                            type="button"
                            className="btn btn-primary w-100"
                            onClick={() =>
                              handleStudentsAction("student_submitted")
                            }
                            style={{
                              background: "#1a73e8",
                              border: "none",
                              borderRadius: "6px",
                              padding: "0.625rem 1.25rem",
                              fontWeight: "600",
                              fontSize: "0.9rem",
                              transition: "all 0.2s",
                              boxShadow: "0 1px 2px rgba(26,115,232,0.25)",
                              minHeight: "42px",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = "#1557b0";
                              e.target.style.boxShadow =
                                "0 2px 4px rgba(26,115,232,0.35)";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = "#1a73e8";
                              e.target.style.boxShadow =
                                "0 1px 2px rgba(26,115,232,0.25)";
                            }}
                          >
                            <i className="fa fa-paper-plane me-2"></i>
                            Submit Application
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Application Modal */}
      {showEditModal && (
        <div
          className="modal fade show d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: "rgba(0,0,0,0.6)",
            backdropFilter: "blur(4px)",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1050,
            padding: "0.125rem", // REDUCED
            boxSizing: "border-box",
            animation: "fadeIn 0.2s ease-out",
          }}
        >
          <div
            className="modal-dialog"
            style={{
              width: "100%",
              maxWidth: "600px",
              margin: "auto",
              maxHeight: "85vh",
              minHeight: "380px",
              animation: "slideUp 0.3s ease-out",
            }}
          >
            <div
              className="modal-content"
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                maxHeight: "85vh",
                height: "auto",
                minHeight: "380px",
                overflow: "hidden",
                borderRadius: "12px",
                border: "1px solid rgba(0,0,0,0.1)",
                boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
              }}
            >
              {/* Modal Header */}
              <div
                className="modal-header"
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  background: "#fff",
                  color: "#1a1a1a",
                  borderBottom: "2px solid #e8eaed",
                  padding: "0.625rem 1rem", // REDUCED
                  minHeight: "55px",
                }}
              >
                <h5
                  className="modal-title"
                  style={{
                    fontWeight: "600",
                    fontSize: "1.1rem",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    color: "#202124",
                  }}
                >
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "8px",
                      background:
                        "linear-gradient(135deg, #ea4335 0%, #c5221f 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "0.85rem",
                    }}
                  >
                    <i className="fa fa-edit"></i>
                  </div>
                  Edit Application
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeEditModal}
                  disabled={editLoading}
                  style={{
                    opacity: 0.6,
                    transition: "opacity 0.2s",
                    fontSize: "0.75rem",
                  }}
                  onMouseEnter={(e) =>
                    !editLoading && (e.target.style.opacity = 1)
                  }
                  onMouseLeave={(e) => (e.target.style.opacity = 0.6)}
                ></button>
              </div>

              {/* Modal Body - Scrollable */}
              <div
                className="modal-body"
                style={{
                  flex: 1,
                  overflowY: "auto",
                  WebkitOverflowScrolling: "touch",
                  minHeight: "280px",
                  padding: "0.75rem 1rem", // REDUCED
                  backgroundColor: "#fafbfc",
                }}
              >
                {editLoading ? (
                  <div
                    className="d-flex flex-column justify-content-center align-items-center"
                    style={{ minHeight: "200px" }}
                  >
                    <div
                      className="spinner-border text-primary"
                      role="status"
                      style={{
                        width: "2rem",
                        height: "2rem",
                        borderWidth: "0.2em",
                      }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p
                      className="mt-2 text-muted"
                      style={{ fontSize: "0.875rem" }}
                    >
                      Loading semester options...
                    </p>
                  </div>
                ) : (
                  <div
                    className="card"
                    style={{
                      border: "none",
                      borderRadius: "8px",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                      minHeight: "220px",
                    }}
                  >
                    <div className="card-body" style={{ padding: "0.75rem" }}>
                      {/* Current Info Card - FIXED LAYOUT */}
                      <div
                        style={{
                          background: "#e8f0fe",
                          padding: "0.5rem 0.75rem", // REDUCED
                          borderRadius: "6px",
                          marginBottom: "0.875rem",
                          border: "1px solid #d2e3fc",
                          minHeight: "70px",
                        }}
                      >
                        {/* FIXED: Better layout for current info */}
                        <div
                          className="current-info-container"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "1rem",
                            flexWrap: "nowrap",
                          }}
                        >
                          <div
                            className="current-info-item"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                              flex: "1",
                              minWidth: "0", // Important for text truncation
                            }}
                          >
                            <span
                              className="fw-semibold"
                              style={{
                                color: "#5f6368",
                                fontSize: "0.8rem",
                                whiteSpace: "nowrap",
                                flexShrink: 0,
                              }}
                            >
                              Current Semester:
                            </span>
                            <span
                              style={{
                                color: "#1a73e8",
                                fontWeight: "600",
                                fontSize: "0.85rem",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {currentSemester || "Loading..."}
                            </span>
                          </div>

                          <div
                            className="current-info-item"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                              flex: "1",
                              minWidth: "0", // Important for text truncation
                              justifyContent: "flex-end",
                            }}
                          >
                            <span
                              className="fw-semibold"
                              style={{
                                color: "#5f6368",
                                fontSize: "0.8rem",
                                whiteSpace: "nowrap",
                                flexShrink: 0,
                              }}
                            >
                              Current Year:
                            </span>
                            <span
                              style={{
                                color: "#1a73e8",
                                fontWeight: "600",
                                fontSize: "0.85rem",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {currentYear || "Loading..."}
                            </span>
                          </div>
                        </div>

                        {/* Return Remark */}
                        {returnRemark && (
                          <div
                            style={{
                              background: "#fce8e6",
                              padding: "0.5rem 0.625rem",
                              borderRadius: "6px",
                              border: "1px solid #f5c2c7",
                              marginTop: "0.625rem",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "start",
                                gap: "0.5rem",
                              }}
                            >
                              <i
                                className="fa fa-exclamation-circle"
                                style={{
                                  color: "#d93025",
                                  marginTop: "0.1rem",
                                  fontSize: "0.75rem",
                                  flexShrink: 0,
                                }}
                              ></i>
                              <div style={{ flex: 1 }}>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    color: "#d93025",
                                    fontSize: "0.75rem",
                                    display: "block",
                                    marginBottom: "0.125rem",
                                  }}
                                >
                                  Principal Remark
                                </span>
                                <span
                                  style={{
                                    color: "#5f6368",
                                    fontSize: "0.75rem",
                                    lineHeight: "1.4",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {returnRemark}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Rest of the form fields remain the same */}
                      <div className="mb-1">
                        <label
                          htmlFor="semesterSelect"
                          className="form-label"
                          style={{
                            fontWeight: "600",
                            color: "#495057",
                            marginBottom: "0.25rem",
                            fontSize: "0.9rem",
                          }}
                        >
                          Select New Semester{" "}
                          <span className="text-danger">*</span>
                        </label>

                        <Select
                          id="semesterSelect"
                          options={availableSemesters}
                          value={selectedSemester}
                          onChange={(option) => setSelectedSemester(option)}
                          placeholder="-- Choose Semester --"
                          isClearable={!semesterDisabled}
                          isDisabled={semesterDisabled}
                          isSearchable={false}
                          openMenuOnFocus={true}
                          classNamePrefix="react-select"
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              borderRadius: "6px",
                              borderColor: state.isFocused
                                ? "#1a73e8"
                                : "#dadce0",
                              boxShadow: state.isFocused
                                ? "0 0 0 2px rgba(26,115,232,0.1)"
                                : "none",
                              transition: "all 0.2s",
                              "&:hover": {
                                borderColor: state.isDisabled
                                  ? "#dadce0"
                                  : "#1a73e8",
                              },
                              fontSize: "0.85rem",
                              backgroundColor: semesterDisabled
                                ? "#f1f3f4"
                                : "white",
                              minHeight: "38px",
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 9999,
                              borderRadius: "6px",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                              border: "1px solid #dadce0",
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isFocused
                                ? "#f1f3f4"
                                : "white",
                              color: "#202124",
                              fontSize: "0.85rem",
                              padding: "6px 10px",
                              "&:active": {
                                backgroundColor: "#e8f0fe",
                              },
                            }),
                          }}
                        />
                      </div>

                      <div className="mb-1">
                        <label
                          htmlFor="readmissionYearSelect"
                          className="form-label"
                          style={{
                            fontWeight: "600",
                            color: "#495057",
                            marginBottom: "0.25rem",
                            fontSize: "0.9rem",
                          }}
                        >
                          Select Readmission Year{" "}
                          <span className="text-danger">*</span>
                        </label>

                        <Select
                          id="readmissionYearSelect"
                          options={readmissionYears}
                          value={selectedYear}
                          onChange={(option) => setSelectedYear(option)}
                          placeholder="-- Choose Year --"
                          isClearable
                          isSearchable={false}
                          openMenuOnFocus={true}
                          classNamePrefix="react-select"
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              borderRadius: "6px",
                              borderColor: state.isFocused
                                ? "#1a73e8"
                                : "#dadce0",
                              boxShadow: state.isFocused
                                ? "0 0 0 2px rgba(26,115,232,0.1)"
                                : "none",
                              transition: "all 0.2s",
                              "&:hover": { borderColor: "#1a73e8" },
                              fontSize: "0.85rem",
                              minHeight: "38px",
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 9999,
                              borderRadius: "6px",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                              border: "1px solid #dadce0",
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isFocused
                                ? "#f1f3f4"
                                : "white",
                              color: "#202124",
                              fontSize: "0.85rem",
                              padding: "6px 10px",
                              "&:active": {
                                backgroundColor: "#e8f0fe",
                              },
                            }),
                          }}
                        />
                      </div>

                      {/* Error Message */}
                      {editError && (
                        <div
                          className="alert alert-danger mt-1"
                          style={{
                            borderRadius: "6px",
                            border: "1px solid #f5c2c7",
                            background: "#fce8e6",
                            padding: "0.375rem 0.625rem",
                            fontSize: "0.75rem",
                            color: "#5f6368",
                            marginBottom: 0,
                          }}
                        >
                          <i
                            className="fa fa-exclamation-circle me-2"
                            style={{ color: "#d93025" }}
                          ></i>
                          {editError}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Modal Footer */}
              <div
                className="modal-footer"
                style={{
                  position: "sticky",
                  bottom: 0,
                  backgroundColor: "#ffffff",
                  borderTop: "1px solid #e8eaed",
                  padding: "0.75rem 1.25rem",
                  gap: "0.75rem",
                  flexWrap: "nowrap",
                  minHeight: "60px",
                }}
              >
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeEditModal}
                  disabled={editLoading || saveLoading}
                  style={{
                    borderRadius: "6px",
                    padding: "0.5rem 1rem",
                    fontWeight: "500",
                    transition: "all 0.2s",
                    background: "#fff",
                    border: "1px solid #dadce0",
                    color: "#f4f4f4",
                    fontSize: "0.85rem",
                    flex: 1,
                    minHeight: "36px",
                    whiteSpace: "nowrap",
                  }}
                  onMouseEnter={(e) => {
                    if (!e.target.disabled) {
                      e.target.style.background = "#f8f9fa";
                      e.target.style.borderColor = "#5f6368";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "#fff";
                    e.target.style.borderColor = "#dadce0";
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSaveEdit}
                  disabled={editLoading || saveLoading || !selectedSemester}
                  style={{
                    background: "#1a73e8",
                    border: "none",
                    borderRadius: "6px",
                    padding: "0.5rem 1rem",
                    fontWeight: "600",
                    transition: "all 0.2s",
                    boxShadow: "0 1px 2px rgba(26,115,232,0.25)",
                    fontSize: "0.85rem",
                    flex: 1,
                    minHeight: "36px",
                    whiteSpace: "nowrap",
                  }}
                  onMouseEnter={(e) => {
                    if (!e.target.disabled) {
                      e.target.style.background = "#1557b0";
                      e.target.style.boxShadow =
                        "0 2px 4px rgba(26,115,232,0.35)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "#1a73e8";
                    e.target.style.boxShadow =
                      "0 1px 2px rgba(26,115,232,0.25)";
                  }}
                >
                  {saveLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-1"></span>
                      Saving...
                    </>
                  ) : (
                    <>
                      <i className="fa fa-save me-1"></i>Save
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }




`}</style>
    </StudentTemplate>
  );
};
export default StudentReadmission;
